import React from 'react';
import { Modal } from '../../components/ui';
import { yesNo, activeOptions } from './useUserManagement';

// Add/Edit user — phone / APK: full screen, one field per row (mobile and
// password share a row), the three switches as big segmented buttons.
// Logic: useUserManagement.
const Seg = ({ label, value, options, onChange }) => (
  <div className="pp-seg-field">{label}
    <div className="pp-seg">
      {options.map(o => (
        <button key={o.value} type="button" style={{ padding: 11 }} className={String(value) === o.value ? 'on' : ''} onClick={() => onChange(o.value)}>{o.label}</button>
      ))}
    </div>
  </div>
);

export default function UserEditFormMobile({ vm }) {
  const { editing, form, setF, saving, close, save } = vm;
  const text = (k) => ({ value: form[k] ?? '', onChange: (e) => setF(k, e.target.value) });
  return (
    <Modal
      fullScreen
      title={editing ? 'Edit User' : 'Add User'}
      onClose={close}
      footer={<>
        <button className="btn light" onClick={close}>Cancel</button>
        <button className="btn primary pp-grow" disabled={saving} onClick={save}>{saving ? 'Saving...' : 'Save'}</button>
      </>}
    >
      <label className="field">Surname<input {...text('Surname')} /></label>
      <label className="field">Name *<input {...text('Name')} /></label>
      <label className="field">Father / Husband<input {...text('FatherHusband')} /></label>
      <label className="field">Mobile Number *<input type="tel" inputMode="numeric" placeholder="10 digits" {...text('MobileNumber')} /></label>
      <label className="field">Email<input type="email" {...text('EmailId')} /></label>
      <label className="field">{editing ? 'New Password' : 'Password *'}
        <input type="password" autoComplete="new-password" placeholder={editing ? 'Leave blank to keep' : ''} {...text('Password')} />
      </label>
      <Seg label="Super Admin" value={form.SuperAdmin} options={yesNo} onChange={v => setF('SuperAdmin', v)} />
      <Seg label="Allow Mobile Login" value={form.AllowUserMobile} options={yesNo} onChange={v => setF('AllowUserMobile', v)} />
      <Seg label="Status" value={form.IsActive} options={activeOptions} onChange={v => setF('IsActive', v)} />
    </Modal>
  );
}
